/** @jsx jsx */
import * as React from "react";
import { css, jsx } from "@emotion/core";
import { INTERVENTIONS_STATUS } from "../../models/IFetchScheduledInterventions";

interface IStatusIndicatorProps { status: INTERVENTIONS_STATUS, height?: number }

export const StatusIndicator: React.FC<IStatusIndicatorProps> = ({ status, height }) => {
    if (status === INTERVENTIONS_STATUS.SCHEDULED) {
        return (<div css={{ margin: 5 }}>
            <img src="/images/incomplete.svg" height={height || 20} />
        </div>)
    } else if (status === INTERVENTIONS_STATUS.MISSED) {
        return (<div css={{ margin: 5 }}>
            <img src="/images/no-response.svg" height={height || 20} />
        </div>)
    } else if (status === INTERVENTIONS_STATUS.DELETED) {
        return (<div css={{ margin: 5 }}>
            <img src="/images/no-response.svg" height={height || 20} />
        </div>)
    } else if (status === INTERVENTIONS_STATUS.DONE) {
        return (<div css={{ margin: 5 }}>
            <img src="/images/complete.svg" height={height || 20} />
        </div>)
    }
    return (<div css={{ margin: 5 }}>N.A</div>)
}